class SortBy extends window.BAO.CustomElement({
  SuperClass: HTMLSelectElement,
}) {
  constructor () {
    super()

    this.state = {
      root: window.theme.category
        ? window.theme.category.stateLayer.state
        : window.theme.searchResults.stateLayer.state,
    }

    this.eventBus = window.theme.category
      ? window.theme.category.eventBus
      : window.theme.searchResults.eventBus
  }

  connectedCallback () {
    this.subscribeToEvents()
  }

  subscribeToEvents () {
    this.addEventListener('change', () => {
      const value = this.value

      this.eventBus.publish('state:sort:updated', value)
    })
  }
}

window.customElements.define('sort-by', SortBy, {
  extends: 'select',
})
